"use strict";

import Common from "../Common";
import CommonGame from "../CommonGame";
import HUD from "./HUD";
import UndoManager  from "./UndoManager";
import Canvas   from "./Canvas";

export default class MyGame {
    constructor() {
        // TODO:

        // Attributes.
        this._scene = null;
        this._decoration = null;
        this._hud = null;
        this._canvas = null;
        this._undoManager = null;
    }

    init() {
        console.assert(this._scene != null, "Initialization failed: this._scene is null.");

        // Undo manager.
        this._undoManager = new UndoManager();

        // Decoration.
        this._decoration = new PIXI.Container();
        this._initDecoration();

        // HUD.
        this._hud = new HUD();
        this._hud.position = new PIXI.Point(Common.STAGE_WIDTH * 0.5, Common.STAGE_HEIGHT * 0.5);
        this._hud.init();

        // Canvas.
        // - Initialization dependencies: HUD.
        this._canvas = new Canvas();
        this._canvas.position = new PIXI.Point(Common.STAGE_WIDTH * 0.5, Common.STAGE_HEIGHT * 0.5);
        this._canvas.init();

        this._scene.gameLayer.addChild(this._canvas);
        this._scene.gameLayer.addChild(this._decoration);
        this._scene.gameLayer.addChild(this._hud);

        //--add an extra overlay so the drawn / colouring is underneath the black lines--//
        const outlineTexture = PIXI.Texture.fromImage("assets/images/outlines/" + ( CommonGame.selectedGallery == CommonGame.GALLERY_ID_DRAW_IT ? "draw_it/" : "colour_it/" ) + CommonGame.selectedImageId + ".png");
        let sp = new PIXI.Sprite(outlineTexture);
        sp.anchor.set(0.5);
        this._canvas.addChild(sp);
    }

    update() {
        this._canvas.update();
    }

    animateIn() {
        this._canvas.animateIn();
    }

    resize() {
        this._hud.resize();
    }

    _initDecoration() {

        const t = Common.assets.texture;

        const topFlowers = new PIXI.Sprite(t("leaves"));
        const offset = topFlowers.height * 0.5;

        topFlowers.anchor.set(0.5, 0.5);
        topFlowers.x = Common.STAGE_WIDTH * 0.5;
        topFlowers.y = -offset;

        const botFlowers = new PIXI.Sprite(t("leaves"));
        botFlowers.anchor.set(0.5, 0.5);
        botFlowers.scale.y = -1;
        botFlowers.x = Common.STAGE_WIDTH * 0.5;
        botFlowers.y = Common.STAGE_HEIGHT + offset;

        this._decoration.addChild(topFlowers, botFlowers);

        TweenMax.to(topFlowers, 2 + Math.random() * 0.5, {
            y: 0,
            ease: Elastic.easeOut.config(1, 0.3 - 0.1 * Math.random()),
            delay: Math.random() * 0.25
        });

        TweenMax.to(botFlowers, 2 + Math.random() * 0.5, {
            y: Common.STAGE_HEIGHT,
            ease: Elastic.easeOut.config(1, 0.3 - 0.1 * Math.random()),
            delay: Math.random() * 0.25
        });
    }

    get scene() {
        return this._scene;
    }

    set scene(value) {
        this._scene = value;
    }

    get hud() {
        return this._hud;
    }

    get canvas() {
        return this._canvas;
    }

    get undoManager() {
        return this._undoManager;
    }
}
